module.exports = __webpack_public_path__ + "static/media/16.6f72c4dc.mp3";